import {
  AlreadyPurchasedContainerProps,
  AlreadyPurchasedSectionRouteMappingProps,
  DiningReservationSnapshot,
  DiningSelectionMetadata,
  OBSObjI,
} from '@msc-b2c/interfaces/types';
import styles from './alreadypurchasedcontainer.module.scss';
import {
  addDaysAtSea,
  AppDispatch,
  closeLoader,
  formatTime,
  getActBaseImagePath,
  getActiveSession,
  getActPlaceholderImagePath,
  getAvailablePrice,
  getCurrencyCode,
  getObsBaseImagePath,
  getObsPlaceholderImagePath,
  isLayerMyAreaExcursionOpen,
  isRefundForAlreadyPurchasedItemsEnabled,
  managePlurals,
  myAreaShopExcursion,
  myAreaShopOBS,
  openLoader,
  PrepaidBookingRefundMyMSC,
  replacePlaceholders,
  RootState,
  selectedMyAreaExcursionCard,
  selectedMyAreaOBSCard,
  setErrorManagerCode,
  setRelatedObsTitlesMap,
  specialtyRestaurants,
  toggleDisplayOverlay,
  updateCartItems,
  useGetBookingQuery,
} from '@msc-b2c/shared-utils';
import { skipToken } from '@reduxjs/toolkit/query';
import { Button, Icon, PostBookingCard, Text, TooltipNew } from '@msc-b2c/shared-components';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { MyMscExcursion } from '@msc-b2c/interfaces/interfaces';
import {
  BookingStatusEnum,
  DiningFlowEntryPoint,
  DiningStepId,
  HeadsUpIconAlignment,
  OBSTypesEnum,
  PriceBasisEnum,
} from '@msc-b2c/interfaces/enums';
import {
  getAlreadyBookedPassengerId,
  getCardImage,
  getMergedBookedPassengerIdsForCombinedObs,
  getNamesOfAlreadyBookedPassengers,
  getPassengerIdsInCartForItemInCabin,
  hasRemainingAddonEligiblePassengersInCabin,
  isNoEligiblePassengersForExcursion,
  isNoEligiblePassengersForOBS,
} from '../postbookingresults/utils/PostBookingResultsUtilities';
import { addToCart, isItemOnCart } from '../utils/myAreaCartUtils';
import HeadsUpContainer from '../postbookingresults/components/drawercontent-subcomponents/HeadsUpContainer';
import {
  areAllPassengersBookedForAlreadyPurchasedItem,
  createEmptyPassengerSelection,
  getAlreadyPurchasedCardCtaMode,
  hasPassengerSelection,
  hasPassengerSelectionExcludingPassengerIds,
  hasRefundablePassengersInCabinForAlreadyPurchased,
  hasRemainingAddonPassengersForAlreadyPurchasedItem,
  isAllInclusiveAlreadyPurchasedItem,
  isAlreadyPurchasedItemPaymentFinalized,
  ItineraryDayDetailsByDate,
  hasSameExcursionStartDate,
  normalizePurchasedExcursionDate,
  resolveExcursionPreTitleFields,
} from './alreadyPurchasedHelpers';
import { navigateOrRedirectToRoute } from '../navigationmenu/utils/navigationMenuUtils';
import {
  triggerAddToCartEvent,
  triggerClickCtaEvent,
  triggerViewItemList,
} from '../utils/myAreaAnalytics';
import { defineItemListName, getContainerInfo } from '../utils/analyticsUtils';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import { AlreadyPurchasedContainerSkeleton } from './AlreadyPurchasedContainerSkeleton';
import {
  getCabinIdOfTheLoggedUser,
  getDepartureDate,
  getShopExcursionData,
  getShopOBSData,
  isPassengerIdInLoggedUserCabin,
} from '../utils/myAreaUtils';
import { normalizeTimeSlots } from '../postbookingresults/components/drawercontent-subcomponents/flowtypes/utils/diningAvailabilityUtils';
import { AllTypes } from '../productcarousel/ProductCarousel';
import { Drawer } from '../drawer/Drawer';
import ImageTitle from '../postbookingresults/components/drawercontent-subcomponents/ImageTitle';
import Overview from '../postbookingresults/components/drawercontent-subcomponents/Overview';
import Passengers from '../postbookingresults/components/drawercontent-subcomponents/Passengers';
import { PassengersSkeleton } from '../postbookingresults/components/drawercontent-subcomponents/PassengersSkeleton';
import CarParkingInput from '../postbookingresults/components/drawercontent-subcomponents/CarParkingInput';
import RefundPassengers from '../postbookingresults/components/drawercontent-subcomponents/RefundPassengers';
import AddToCartOverview from '../postbookingresults/components/drawercontent-subcomponents/AddToCartOverview';
import { DiningMultistepDrawer } from '../postbookingresults/components/drawercontent-subcomponents/flowtypes/DiningMultistepDrawer';
import {
  extractLongDescription,
  extractTooltipContent,
} from '../postbookingresults/utils/TooltipUtilities';
import passengerDrawerStyles from '../postbookingresults/components/drawercontent-subcomponents/passengers.module.scss';
import {
  getSelectedRefundCabinIds,
  getSelectedRefundPassengerIds,
  isRefundResponseSuccessful,
} from './refundHelpers';
import {
  getCmsRelatedCodes,
  getLinkedMinorObs,
  isAllInclusiveByCmsOrTypeCode,
  isAllInclusiveOrCombinedObsRefund,
  isHiddenMinorObs,
} from '../postbookingresults/utils/allInclusiveCmsHelpers';
import {
  getCabinsWithPassengersForCruise,
  sortCabinsByPassengerOrder,
} from '../utils/stateroomGenericUtils';
import { useAlreadyPurchasedDiningRevise } from '../postbookingresults/components/drawercontent-subcomponents/flowtypes/hooks/useAlreadyPurchasedDiningRevise';
import HeadsUpInfo, {
  HeadsUpMessagePriority,
} from '../postbookingresults/components/drawercontent-subcomponents/HeadsUpInfo';
import { isMultiCabins } from '../utils/utils';
import { refreshAllInclusiveCatalog } from '../utils/refreshAllInclusiveCatalog';
import { getRestaurantInfoFromGraphql } from '../postbookingresults/components/drawercontent-subcomponents/flowtypes/utils/diningRestaurantInfoFromCF';

export function AlreadyPurchasedContainer({
  title,
  editButtonLabel,
  viewDetailButtonLabel,
  specialtyRestaurantMakeReservationLabel,
  specialtyRestaurantRequestRefundLabel,
  specialtyRestaurantReservationsLabel,
  specialtyRestaurantConfirmReservationLabel,
  diningBannerTitle,
  diningBannerIcon,
  diningBannerBackgroundColor,
  diningBannerFontColor,
  diningBannerText,
  diningTimeslotsUnavailableBannerTitle,
  diningTimeslotsUnavailableBannerBody,
  diningTimeslotsUnavailableBannerIcon,
  diningTimeslotsUnavailableBannerBgColor,
  diningTimeslotsUnavailableBannerFontColor,
  passengerDetailsSeparator = '',
}: Readonly<AlreadyPurchasedContainerProps>) {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [excursionsPurchased, setExcursionsPurchased] = useState<MyMscExcursion[]>();
  const [obsPurchased, setObsPurchased] = useState<OBSObjI[]>();
  const [showSkeleton, setShowSkeleton] = useState(true);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isRefundConfirmationOpen, setIsRefundConfirmationOpen] = useState(false);
  const [isRefundProcessing, setIsRefundProcessing] = useState(false);
  const [isRefundSuccessOpen, setIsRefundSuccessOpen] = useState(false);
  const [isRefundErrorOpen, setIsRefundErrorOpen] = useState(false);
  const [refundSuccessDescription, setRefundSuccessDescription] = useState('');
  const [refundErrorDescription, setRefundErrorDescription] = useState('');
  const [passengersToAdd, setPassengersToAdd] = useState<Record<
    string,
    Record<string, boolean>
  > | null>(null);
  const [selectedLanguages, setSelectedLanguages] = useState<Record<string, string>>({});
  const [refundPassengersToProcess, setRefundPassengersToProcess] = useState<
    Record<string, Record<string, boolean>>
  >({});
  const [pendingDiningRefundSelection, setPendingDiningRefundSelection] = useState<Record<
    string,
    Record<string, boolean>
  > | null>(null);
  const [isShopRequestFailed, setIsShopRequestFailed] = useState(false);
  const [isShopLoading, setIsShopLoading] = useState(false);
  const [shouldShowAddOnSection, setShouldShowAddOnSection] = useState(false);
  const [isConfirmationDrawer, setIsConfirmationDrawer] = useState(false);
  const [triggerAddToCart, setTriggerAddToCart] = useState(false);
  const [isAddPassengersProcessing, setIsAddPassengersProcessing] = useState(false);
  const [isViewDetailDrawer, setIsViewDetailDrawer] = useState(false);
  const [addonSelectionResetKey, setAddonSelectionResetKey] = useState(0);
  const [refundSelectionResetKey, setRefundSelectionResetKey] = useState(0);
  const [allPassengersInCart, setAllPassengersInCart] = useState(false);
  const [allPassengersInCartByCabin, setAllPassengersInCartByCabin] = useState<
    Record<string, boolean>
  >({});

  const specialityRestaurantsFromCf = useSelector(
    (state: RootState) => state.myAreaCommonConfig.specialtyRestaurants
  );

  const [shopRequestToRestaurants, setShopRequestToRestaurants] = useState<boolean>(false);

  const [carParkingInput, setCarParkingInput] = useState<{ model: string; plate: string }>({
    model: '',
    plate: '',
  });
  const [isDiningDrawerOpen, setIsDiningDrawerOpen] = useState(false);
  const [selectedRestaurantObs, setSelectedRestaurantObs] = useState<OBSObjI | null>(null);
  const [selectedRestaurantReservations, setSelectedRestaurantReservations] = useState<
    DiningReservationSnapshot[]
  >([]);
  const [selectedRestaurantPassengers, setSelectedRestaurantPassengers] = useState<
    Record<string, Record<string, boolean>> | undefined
  >(undefined);
  const [diningDrawerInitialStep, setDiningDrawerInitialStep] = useState<DiningStepId>(
    DiningStepId.DATE_TIME_SELECTION
  );
  const [isDiningButtonLoading, setIsDiningButtonLoading] = useState(false);
  const hasTriggeredViewItemList = useRef(false);
  const refundAbortControllerRef = useRef<AbortController | null>(null);
  const { bookingNumber = '', cruiseId, loginMode } = getActiveSession();
  const { data: booking, refetch: refetchBooking } = useGetBookingQuery(bookingNumber || skipToken);
  const {
    cacheDiningSelectionFromDrawer,
    resetPendingDiningSelection,
    applyDiningSelectionRevise,
    applyDiningSelectionReviseDirect,
  } = useAlreadyPurchasedDiningRevise({
    booking,
    bookingNumber,
    cruiseId,
    onboardServiceCode: selectedRestaurantObs?.code,
  });
  const { alreadyPurchasedSectionRouteMapping } = useSelector(
    (state: RootState) => state.navigationMenuData
  );
  const {
    excursions,
    obs,
    cabinDetails,
    allInclusiveCmsItems,
    shopExcursion,
    shopOBS,
    itinerary,
    membershipData,
  } = useSelector((state: RootState) => state.myCruise);
  const itineraryDetailsData = useSelector(
    (state: RootState) => state.itineraryDetails?.itineraryDetailsData ?? null
  );
  const {
    prePaidCardProps: propertiesFromPlanMyCruiseContainer,
    drawerProps,
    confirmationDrawerProps,
  } = useSelector((state: RootState) => state.myAreaCommonConfig);
  const drawerExcursionAEMConfig = useSelector(
    (state: RootState) => state.myAreaCommonConfig?.drawerExcursionProps?.drawerExcursionType
  );
  const {
    selectedMyAreaExcursionCard: selectedExcursionCard,
    selectedMyAreaOBSCard: selectedOBSCard,
    isLayerMyAreaExcursionOpen: isExcursionLayerOpen,
    drawerPrice,
  } = useSelector((state: RootState) => state.myAreaDrawers);
  const cartItems = useSelector((state: RootState) => state.myAreaCart.items);

  const allObsCatalog = useMemo(() => {
    const byCode = new Map<string, OBSObjI>();
    obsPurchased?.forEach((obsItem) => {
      if (obsItem.code) {
        byCode.set(obsItem.code, obsItem);
      }
    });
    obs?.onboardServices?.forEach((obsItem) => {
      if (obsItem.code) {
        byCode.set(obsItem.code, { ...byCode.get(obsItem.code), ...obsItem });
      }
    });
    return [...byCode.values()];
  }, [obsPurchased, obs?.onboardServices]);

  const activeCabinId = useMemo(() => {
    return getCabinIdOfTheLoggedUser(booking);
  }, [booking]);

  const urlAct = getActBaseImagePath() || '/content/dam/msc-cruises/b2c-assets/act';
  const urlObs = getObsBaseImagePath() || '/content/dam/msc-cruises/b2c-assets/obs';

  const isBookingItemInActiveCabin = useCallback(
    (item: { passenger?: { id: string }; cabin?: { id: string } }): boolean => {
      if (!activeCabinId || !booking) {
        return false;
      }

      if (item.cabin?.id) {
        return item.cabin.id === activeCabinId;
      }

      if (item.passenger?.id) {
        return isPassengerIdInLoggedUserCabin(booking, activeCabinId, item.passenger.id);
      }

      return false;
    },
    [activeCabinId, booking]
  );

  const isMultiCabinBooking = useMemo(
    () => Boolean(booking && cruiseId && isMultiCabins(booking, cruiseId)),
    [booking, cruiseId]
  );

  useEffect(() => {
    if (obs?.onboardServices && excursions?.excursions && booking) {
      requestAnimationFrame(() => {
        setShowSkeleton(false);
      });
    }
  }, [obs, excursions, booking]);

  useEffect(() => {
    const excursionsMap = new Map<string, MyMscExcursion>();
    const excursionsKeysByCode = new Map<string, string[]>();

    const getExcursionDateKey = (startDate?: string) =>
      normalizePurchasedExcursionDate(startDate) ?? startDate ?? '';

    const getExcursionMapKey = (code: string, startDate?: string) =>
      `${code}::${getExcursionDateKey(startDate)}`;

    const registerExcursionKey = (code: string, key: string) => {
      const existingKeys = excursionsKeysByCode.get(code) ?? [];
      if (!existingKeys.includes(key)) {
        excursionsKeysByCode.set(code, [...existingKeys, key]);
      }
    };

    if (booking?.prepaid?.bookings && cruiseId) {
      booking.prepaid.bookings
        .filter((item) => item.cruise.id === cruiseId)
        .forEach((item) => {
          item.excursions
            ?.filter(
              (exc) =>
                isBookingItemInActiveCabin(exc) &&
                exc.bookingStatus?.code === BookingStatusEnum.BOOKED
            )
            .forEach((exc) => {
              const excursionKey = getExcursionMapKey(exc.code, exc.startDate);
              excursionsMap.set(excursionKey, {
                code: exc.code,
                description: exc.description,
                startDate: normalizePurchasedExcursionDate(exc.startDate) || exc.startDate,
                isPackage: exc.isPackage ?? false,
                longDescription: exc.longDescription ?? '',
                duration: exc.duration ?? 0,
                ...(exc.activityDetails || exc.minimumPassengersRequired != null
                  ? {
                      activityDetails: {
                        ...exc.activityDetails,
                        guideLanguageCodes: exc.activityDetails?.guideLanguageCodes ?? [],
                        minimumPassengersRequired: exc.minimumPassengersRequired,
                      },
                    }
                  : {}),
              } as MyMscExcursion);
              registerExcursionKey(exc.code, excursionKey);
            });
        });
    }

    excursions?.excursions?.forEach((excursion: MyMscExcursion) => {
      const matchingKeys = excursionsKeysByCode.get(excursion.code) ?? [];
      if (matchingKeys.length > 0) {
        const exactStartDateKey = getExcursionMapKey(excursion.code, excursion.startDate);
        const keysToUpdate = excursionsMap.has(exactStartDateKey)
          ? [exactStartDateKey]
          : matchingKeys.length === 1
          ? matchingKeys
          : [];

        keysToUpdate.forEach((key) => {
          const bookingExcursion = excursionsMap.get(key);
          if (!bookingExcursion) {
            return;
          }

          excursionsMap.set(key, {
            ...bookingExcursion,
            ...excursion,
            startDate:
              normalizePurchasedExcursionDate(bookingExcursion.startDate) ||
              normalizePurchasedExcursionDate(excursion.startDate) ||
              bookingExcursion.startDate ||
              excursion.startDate,
          });
        });
      }
    });

    setExcursionsPurchased([...excursionsMap.values()]);

    const obsMap = new Map<string, OBSObjI>();

    if (booking?.prepaid?.bookings && cruiseId) {
      booking.prepaid.bookings
        .filter((item) => item.cruise.id === cruiseId)
        .forEach((item) => {
          item.onboardServices
            ?.filter(
              (service) =>
                isBookingItemInActiveCabin(service) &&
                service.bookingStatus?.code === BookingStatusEnum.BOOKED
            )
            .forEach((service) => {
              obsMap.set(service.code, {
                code: service.code,
                description: service.description,
                type: { code: service.type },
                deliveryDate: service.deliveryDate,
                longDescription: service.longDescription,
              } as OBSObjI);
            });
        });
    }

    obs?.onboardServices?.forEach((service: OBSObjI) => {
      if (service.code && obsMap.has(service.code)) {
        obsMap.set(service.code, { ...obsMap.get(service.code)!, ...service });
      }
    });

    setObsPurchased([...obsMap.values()]);
  }, [excursions, obs, booking, cruiseId, isBookingItemInActiveCabin]);

  useEffect(() => {
    if (specialityRestaurantsFromCf.length === 0) {
      getRestaurantInfoFromGraphql().then((restaurantItems) => {
        if (restaurantItems) {
          dispatch(specialtyRestaurants(restaurantItems));
        }
      });
    }
  }, []);

  useEffect(() => {
    if (!obsPurchased?.length) {
      return;
    }

    const obsByCode = new Map(obsPurchased.map((obsItem) => [obsItem.code, obsItem]));
    const relatedItemsMap: Record<string, string[]> = {};

    obsPurchased.forEach((obsItem) => {
      const relatedCodes = [
        ...(obsItem.prepaidItems?.serviceCodes?.adults ?? []),
        ...(obsItem.prepaidItems?.serviceCodes?.minors ?? []),
        ...getCmsRelatedCodes(allInclusiveCmsItems, obsItem.code),
      ]
        .filter((code): code is string => Boolean(code))
        .filter((code) => code !== obsItem.code);

      const firstRelatedDescription = relatedCodes
        .map((code) => obsByCode.get(code)?.description ?? null)
        .find((desc): desc is string => Boolean(desc));

      if (firstRelatedDescription && obsItem.code) {
        relatedItemsMap[obsItem.code] = [firstRelatedDescription];
      }
    });

    dispatch(setRelatedObsTitlesMap(relatedItemsMap));
  }, [obsPurchased, allInclusiveCmsItems, dispatch]);

  const diningTimeslotsUnavailableByCode = useMemo(() => {
    const unavailableByCode: Record<string, boolean> = {};
    const purchasedRestaurantCodes = new Set(
      (obsPurchased ?? [])
        .filter((service) => service.type?.code === OBSTypesEnum.RESTAURANTS)
        .map((service) => service.code)
        .filter((code): code is string => Boolean(code))
    );

    if (purchasedRestaurantCodes.size === 0) {
      return unavailableByCode;
    }

    const int130RestaurantByCode = new Map(
      (obs?.onboardServices ?? [])
        .filter(
          (service): service is OBSObjI & { code: string } =>
            service.type?.code === OBSTypesEnum.RESTAURANTS && Boolean(service.code)
        )
        .map((service) => [service.code, service])
    );

    purchasedRestaurantCodes.forEach((restaurantCode) => {
      const restaurantFromInt130 = int130RestaurantByCode.get(restaurantCode);
      if (!restaurantFromInt130) {
        return;
      }

      const hasAtLeastOneTimeslot = (restaurantFromInt130.diningRooms ?? []).some(
        (diningRoom) => normalizeTimeSlots(diningRoom.timeSlots).length > 0
      );

      if (!hasAtLeastOneTimeslot) {
        unavailableByCode[restaurantCode] = true;
      }
    });

    return unavailableByCode;
  }, [obs?.onboardServices, obsPurchased]);

  const orderedSectionRouteMapping = alreadyPurchasedSectionRouteMapping ?? [];
  const fallbackSectionRouteMapping = useMemo<AlreadyPurchasedSectionRouteMappingProps[]>(() => {
    const fallbackSections: AlreadyPurchasedSectionRouteMappingProps[] = [];

    if ((excursionsPurchased?.length ?? 0) > 0) {
      fallbackSections.push({
        routeUrl: {},
        routeTypes: { ACT: 'ACT' },
        routeLabel: 'Excursions',
        routeDescription: '',
        ctaLabel: '',
      });
    }

    const obsTypeCodes = Array.from(
      new Set((obsPurchased ?? []).map((service) => service.type?.code).filter(Boolean))
    ) as string[];

    obsTypeCodes.forEach((typeCode) => {
      fallbackSections.push({
        routeUrl: {},
        routeTypes: { [typeCode]: typeCode },
        routeLabel: typeCode,
        routeDescription: '',
        ctaLabel: '',
      });
    });

    return fallbackSections;
  }, [excursionsPurchased, obsPurchased]);
  const effectiveSectionRouteMapping =
    orderedSectionRouteMapping.length > 0
      ? orderedSectionRouteMapping
      : fallbackSectionRouteMapping;

  const allIndexedCards = useMemo(() => {
    if (!booking || !excursionsPurchased || !obsPurchased) return undefined;

    const result: (AllTypes & { index?: number; itemCategory2?: string })[] = [];
    let index = 1;

    effectiveSectionRouteMapping.forEach((type) => {
      const isExcursionSection = Object.keys(type.routeTypes).find(
        (routeType) => 'ACT' === routeType
      );
      if (isExcursionSection) {
        if (excursionsPurchased.length > 0) {
          excursionsPurchased.forEach((exc) => {
            result.push({ ...exc, index: index++, itemCategory2: 'excursions' });
          });
        }
      } else {
        const specificTypeObs = obsPurchased.filter(
          (obs) =>
            Object.keys(type.routeTypes).find((routeType) => routeType === obs.type.code) &&
            // Minor ALLINC packages are merged into the linked adult card, never shown separately.
            !isHiddenMinorObs(obs, allObsCatalog, allInclusiveCmsItems)
        );
        specificTypeObs.forEach((obs) => {
          result.push({ ...obs, index: index++, itemCategory2: type.routeLabel.toLowerCase() });
        });
      }
    });

    return result;
  }, [
    effectiveSectionRouteMapping,
    excursionsPurchased,
    obsPurchased,
    booking,
    allInclusiveCmsItems,
    allObsCatalog,
  ]);

  useEffect(() => {
    if (
      !showSkeleton &&
      !hasTriggeredViewItemList.current &&
      allIndexedCards &&
      allIndexedCards.length > 0 &&
      booking &&
      cabinDetails &&
      membershipData
    ) {
      hasTriggeredViewItemList.current = true;
      triggerViewItemList(allIndexedCards, booking, null, cabinDetails, membershipData);
    }
  }, [showSkeleton, allIndexedCards, booking, cabinDetails, membershipData]);

  const isRefundEnabled = loginMode === 'full' && isRefundForAlreadyPurchasedItemsEnabled();
  const resolvedViewDetailButtonLabel = viewDetailButtonLabel ?? editButtonLabel;

  const resetDrawerState = () => {
    setIsRefundProcessing(false);
    setIsRefundSuccessOpen(false);
    setIsRefundErrorOpen(false);
    setRefundErrorDescription('');
    setIsRefundConfirmationOpen(false);
    setIsConfirmationDrawer(false);
    setTriggerAddToCart(false);
    setIsAddPassengersProcessing(false);
    setIsViewDetailDrawer(false);
    setIsDrawerOpen(false);
    setPassengersToAdd(null);
    setSelectedLanguages({});
    setRefundPassengersToProcess({});
    setAllPassengersInCart(false);
    setAllPassengersInCartByCabin({});
    setCarParkingInput({ model: '', plate: '' });
    setPendingDiningRefundSelection(null);
    setIsShopRequestFailed(false);
    setIsShopLoading(false);
    setShouldShowAddOnSection(false);
    toggleDisplayOverlay(false);
    dispatch(isLayerMyAreaExcursionOpen(false));
    dispatch(selectedMyAreaExcursionCard(null));
    dispatch(selectedMyAreaOBSCard(null));
  };

  useEffect(() => {
    if (!passengersToAdd || !triggerAddToCart) {
      return;
    }

    const activeCard = isExcursionLayerOpen ? selectedExcursionCard : selectedOBSCard;
    if (!activeCard) {
      return;
    }
    const carParkInfo =
      !isExcursionLayerOpen && selectedOBSCard?.type?.code === 'PARK'
        ? {
            plate: carParkingInput.plate,
            model: carParkingInput.model,
          }
        : undefined;
    const updatedCart = addToCart(activeCard, passengersToAdd, carParkInfo, {
      selectedLanguages,
      itemListName: defineItemListName(activeCard),
    });
    dispatch(updateCartItems(updatedCart));
    setTriggerAddToCart(false);
    setIsAddPassengersProcessing(false);
    if (confirmationDrawerProps?.showConfirmationDrawer) {
      setIsConfirmationDrawer(true);
    } else {
      resetDrawerState();
    }
  }, [
    passengersToAdd,
    triggerAddToCart,
    dispatch,
    isExcursionLayerOpen,
    selectedExcursionCard,
    selectedOBSCard,
    selectedLanguages,
    carParkingInput.model,
    carParkingInput.plate,
    confirmationDrawerProps?.showConfirmationDrawer,
  ]);

  const getCardCtaMode = (card: MyMscExcursion | OBSObjI, isExcursion: boolean) =>
    getAlreadyPurchasedCardCtaMode({
      card,
      booking,
      cruiseId: cruiseId || undefined,
      activeCabinId,
      isExcursion,
      isRefundEnabled,
      isAllInclusiveItem: isAllInclusiveAlreadyPurchasedItem(
        card,
        allInclusiveCmsItems,
        isExcursion
      ),
      cartItems,
      shopExcursion,
      shopOBS,
    });

  const activeDrawerCardForSelection = (
    isExcursionLayerOpen ? selectedExcursionCard : selectedOBSCard
  ) as MyMscExcursion | OBSObjI | null;

  const drawerCabinIdsForCart = useMemo(
    () =>
      booking?.cabins
        ?.filter((cabin) => cabin.cruise?.id === cruiseId)
        .map((cabin) => cabin.id)
        .filter((id): id is string => Boolean(id)) ?? [],
    [booking, cruiseId]
  );

  const passengerIdsInCartForActiveCard = useMemo(() => {
    if (!activeDrawerCardForSelection || !cartItems?.length || !booking) {
      return new Set<string>();
    }

    const ids = new Set<string>();
    drawerCabinIdsForCart.forEach((cabinId) => {
      getPassengerIdsInCartForItemInCabin(
        activeDrawerCardForSelection,
        cartItems,
        booking,
        cabinId
      ).forEach((id) => ids.add(id));
    });
    return ids;
  }, [activeDrawerCardForSelection, cartItems, booking, drawerCabinIdsForCart]);

  const handleRefundPassengersChange = (checked: Record<string, Record<string, boolean>>) => {
    if (hasPassengerSelection(checked)) {
      setPassengersToAdd(
        createEmptyPassengerSelection(booking, cruiseId || undefined, activeCabinId)
      );
      setAddonSelectionResetKey((key) => key + 1);
    }
    setRefundPassengersToProcess(checked);
  };

  const handleAddonPassengersChange = (checked: Record<string, Record<string, boolean>>) => {
    if (hasPassengerSelectionExcludingPassengerIds(checked, passengerIdsInCartForActiveCard)) {
      setRefundPassengersToProcess({});
      setRefundSelectionResetKey((key) => key + 1);
    }
    setPassengersToAdd(checked);
  };

  const handleAddPassengersToCart = () => {
    const isParkObs = !isExcursionLayerOpen && selectedOBSCard?.type?.code === 'PARK';
    if (
      !hasNewAddonPassengersSelected ||
      allEligiblePassengersInCart ||
      (isParkObs && (!carParkingInput?.model.trim() || !carParkingInput?.plate.trim()))
    ) {
      return;
    }
    toggleDisplayOverlay(false);
    setTriggerAddToCart(true);
    setIsAddPassengersProcessing(true);
    const activeCard = isExcursionLayerOpen ? selectedExcursionCard : selectedOBSCard;
    triggerAddToCartEvent(
      activeCard,
      booking,
      cabinDetails,
      getCurrencyCode(),
      getAvailablePrice(drawerPrice),
      { passengersToAdd },
      membershipData
    );
  };

  const handleNavigateToCart = () => {
    resetDrawerState();
    navigateOrRedirectToRoute(confirmationDrawerProps?.viewCartLink || {}, navigate);
  };

  const openAlreadyPurchasedDrawer = (
    card: MyMscExcursion | OBSObjI,
    isExcursion: boolean,
    ctaMode: ReturnType<typeof getCardCtaMode>
  ) => {
    const isAllInclusiveItem = isAllInclusiveAlreadyPurchasedItem(
      card,
      allInclusiveCmsItems,
      isExcursion
    );
    const isViewDetail = ctaMode === 'viewDetail';

    setPassengersToAdd(null);
    setSelectedLanguages({});
    setRefundPassengersToProcess({});
    setAddonSelectionResetKey((key) => key + 1);
    setRefundSelectionResetKey((key) => key + 1);
    setAllPassengersInCart(false);
    setAllPassengersInCartByCabin({});
    setCarParkingInput({ model: '', plate: '' });
    setIsViewDetailDrawer(isViewDetail);
    setIsShopRequestFailed(false);
    setIsShopLoading(false);
    setShouldShowAddOnSection(false);
    setIsDrawerOpen(true);
    dispatch(isLayerMyAreaExcursionOpen(isExcursion));
    if (isExcursion) {
      dispatch(selectedMyAreaOBSCard(null));
      dispatch(selectedMyAreaExcursionCard(card as MyMscExcursion));
    } else {
      dispatch(selectedMyAreaExcursionCard(null));
      dispatch(selectedMyAreaOBSCard(card as OBSObjI));
    }

    if (isViewDetail) {
      return;
    }

    if (isAllInclusiveItem) {
      setShouldShowAddOnSection(false);
      return;
    }

    if (isExcursion) {
      setIsShopLoading(true);
      getShopExcursionData(card as MyMscExcursion)
        .then((res) => {
          const isErrorResponse =
            !res || typeof res !== 'object' || !('prices' in res) || !('code' in res);
          if (isErrorResponse) {
            setIsShopRequestFailed(true);
            setShouldShowAddOnSection(false);
            setIsShopLoading(false);
            return;
          }
          setIsShopRequestFailed(false);
          setShouldShowAddOnSection(true);
          setIsShopLoading(false);
          dispatch(myAreaShopExcursion(res));
        })
        .catch(() => {
          setIsShopRequestFailed(true);
          setShouldShowAddOnSection(false);
          setIsShopLoading(false);
        });
      return;
    }

    setIsShopLoading(true);
    getShopOBSData(card as OBSObjI)
      .then((res) => {
        const isErrorResponse =
          !res || typeof res !== 'object' || !('prices' in res) || !('code' in res);
        if (isErrorResponse) {
          setIsShopRequestFailed(true);
          setShouldShowAddOnSection(false);
          setIsShopLoading(false);
          return;
        }
        setIsShopRequestFailed(false);
        setShouldShowAddOnSection(true);
        setIsShopLoading(false);
        dispatch(myAreaShopOBS(res));
      })
      .catch(() => {
        setIsShopRequestFailed(true);
        setShouldShowAddOnSection(false);
        setIsShopLoading(false);
      });
  };

  const handleOpenExcursionDrawer = (excursion: MyMscExcursion) => {
    const ctaMode = getCardCtaMode(excursion, true);
    if (ctaMode === 'hidden') {
      return;
    }
    openAlreadyPurchasedDrawer(excursion, true, ctaMode);
  };

  const handleOpenObsDrawer = (obsCard: OBSObjI) => {
    const selectedObsFromCatalog =
      allObsCatalog.find((item) => item.code === obsCard.code) ?? obsCard;
    const ctaMode = getCardCtaMode(selectedObsFromCatalog, false);
    if (ctaMode === 'hidden') {
      return;
    }
    openAlreadyPurchasedDrawer(selectedObsFromCatalog, false, ctaMode);
  };

  const isDiningObsItem = (obsCard: OBSObjI): boolean =>
    obsCard?.type?.code === OBSTypesEnum.RESTAURANTS;

  const itineraryDayDetailsByDate = useMemo(() => {
    const itinerarySource = itinerary ?? itineraryDetailsData;
    if (!itinerarySource?.days || itinerarySource.days.length === 0) {
      return new Map<string, ItineraryDayDetailsByDate>();
    }

    const days = addDaysAtSea(
      itinerarySource,
      propertiesFromPlanMyCruiseContainer.dayAtSeaLabelValue ?? ''
    ).days;
    const dayDetailsByDate = new Map<string, ItineraryDayDetailsByDate>();

    days.forEach((day, dayIndex) => {
      const date = normalizePurchasedExcursionDate(day.date);
      if (!date) {
        return;
      }

      if (dayDetailsByDate.has(date)) {
        return;
      }

      const portName = day.port?.name;
      const isAtSea =
        day.port?.code === 'SEA' ||
        ('dayAtSea' in day && Boolean((day as { dayAtSea?: boolean }).dayAtSea)) ||
        !portName;

      dayDetailsByDate.set(date, {
        dayNumber: dayIndex + 1,
        portName,
        portCode: day.port?.code,
        isAtSea,
      });
    });

    return dayDetailsByDate;
  }, [itinerary, itineraryDetailsData, propertiesFromPlanMyCruiseContainer.dayAtSeaLabelValue]);

  const sortDiningReservationsChronologically = (
    reservations: readonly DiningReservationSnapshot[]
  ): DiningReservationSnapshot[] => {
    return [...reservations].sort((left, right) => {
      const leftTimestamp = new Date(`${left.day}T${left.hour}`).getTime();
      const rightTimestamp = new Date(`${right.day}T${right.hour}`).getTime();

      if (!Number.isNaN(leftTimestamp) && !Number.isNaN(rightTimestamp)) {
        return leftTimestamp - rightTimestamp;
      }

      const leftDateCompare = left.day.localeCompare(right.day);
      if (leftDateCompare !== 0) {
        return leftDateCompare;
      }

      return left.hour.localeCompare(right.hour);
    });
  };

  const formatDiningReservationSummary = useCallback(
    (reservation: DiningReservationSnapshot, showRestaurantName = false): string => {
      const reservationDateDetails = itineraryDayDetailsByDate.get(reservation.day);
      const cmsDayLabelTemplate = propertiesFromPlanMyCruiseContainer.dayLabel ?? 'Day';
      const dayAtSeaLabel = propertiesFromPlanMyCruiseContainer.dayAtSeaLabelValue ?? 'Day at sea';
      const reservationDayNumber = reservationDateDetails?.dayNumber;

      const daySegment = (() => {
        if (!reservationDayNumber) {
          return 'Day';
        }

        const resolvedLabel = replacePlaceholders(cmsDayLabelTemplate, {
          dayNumber: String(reservationDayNumber),
          portName: '',
        })
          .replace(/\{[^}]+\}/g, '')
          .replace(/\s*-\s*$/, '')
          .replace(/\s{2,}/g, ' ')
          .trim();

        return resolvedLabel || `Day ${reservationDayNumber}`;
      })();

      const locationSegment = reservationDateDetails?.isAtSea
        ? dayAtSeaLabel
        : reservationDateDetails?.portName ?? dayAtSeaLabel;

      return [
        daySegment,
        locationSegment,
        ...(showRestaurantName
          ? [
              specialityRestaurantsFromCf?.find(
                (resCF) => resCF.roomCode === reservation.restaurantCode
              )?.restaurantName ||
                reservation.restaurantName ||
                '',
            ]
          : []),
        formatTime(reservation.hour),
      ]
        .filter((segment): segment is string => Boolean(segment && segment.trim().length > 0))
        .join(', ');
    },
    [
      itineraryDayDetailsByDate,
      propertiesFromPlanMyCruiseContainer.dayAtSeaLabelValue,
      propertiesFromPlanMyCruiseContainer.dayLabel,
      specialityRestaurantsFromCf,
    ]
  );

  const getBookedDiningReservations = (obsCard: OBSObjI): DiningReservationSnapshot[] => {
    if (!booking?.prepaid?.bookings || !cruiseId || !obsCard.code) {
      return [];
    }

    const reservations = booking.prepaid.bookings
      .filter((item) => item.cruise.id === cruiseId)
      .flatMap((item) => item.onboardServices ?? [])
      .filter(
        (service) =>
          service.code === obsCard.code &&
          service.type === OBSTypesEnum.RESTAURANTS &&
          service.bookingStatus?.code === BookingStatusEnum.BOOKED &&
          isBookingItemInActiveCabin(service)
      )
      .flatMap((service) => service.diningRooms ?? [])
      .filter((reservation) => Boolean(reservation.code && reservation.date && reservation.slot))
      .map((reservation) => ({
        restaurantCode: reservation.code ?? '',
        day: reservation.date?.split('T')[0] ?? '',
        hour: reservation.slot ?? '',
        restaurantName: reservation.description,
      }));

    return reservations.filter(
      (reservation, index, list) =>
        list.findIndex(
          (candidate) =>
            candidate.restaurantCode === reservation.restaurantCode &&
            candidate.day === reservation.day &&
            candidate.hour === reservation.hour
        ) === index
    );
  };

  const handleMakeRestaurantReservation = (
    obsCard: OBSObjI,
    reservations: DiningReservationSnapshot[],
    preselectedPassengers?: Record<string, Record<string, boolean>>
  ) => {
    dispatch(selectedMyAreaOBSCard(obsCard));
    dispatch(isLayerMyAreaExcursionOpen(false));
    dispatch(selectedMyAreaExcursionCard(null));
    setSelectedRestaurantObs(obsCard);
    setSelectedRestaurantReservations(reservations);
    setSelectedRestaurantPassengers(preselectedPassengers);
    setDiningDrawerInitialStep(DiningStepId.DATE_TIME_SELECTION);
    setIsDiningDrawerOpen(true);
  };

  const handleEditRestaurantReservation = (
    obsCard: OBSObjI,
    reservations: DiningReservationSnapshot[],
    preselectedPassengers?: Record<string, Record<string, boolean>>
  ) => {
    dispatch(isLayerMyAreaExcursionOpen(false));
    dispatch(selectedMyAreaExcursionCard(null));
    dispatch(selectedMyAreaOBSCard(obsCard));
    setSelectedRestaurantObs(obsCard);
    setSelectedRestaurantReservations(reservations);
    setSelectedRestaurantPassengers(preselectedPassengers);
    setDiningDrawerInitialStep(DiningStepId.CART_RESERVATION_RECAP);
    setIsDiningDrawerOpen(true);
  };

  const resetDiningDrawerState = () => {
    setIsDiningDrawerOpen(false);
    setSelectedRestaurantObs(null);
    setSelectedRestaurantReservations([]);
    setSelectedRestaurantPassengers(undefined);
    dispatch(selectedMyAreaOBSCard(null));
    resetPendingDiningSelection();
  };

  const handleCloseDiningDrawer = () => {
    resetDiningDrawerState();
  };

  const handleDiningDrawerConfirm = async () => {
    resetDiningDrawerState();
    setShowSkeleton(true);
    await refetchBooking();
    setShowSkeleton(false);
  };

  const handleDiningConfirmPassengers = (
    passengers: Record<string, Record<string, boolean>>,
    _step: DiningStepId,
    diningSelection?: DiningSelectionMetadata
  ) => {
    cacheDiningSelectionFromDrawer(passengers, diningSelection);
  };

  const handlePersistDiningSelectionForAlreadyPurchased = async (
    passengers: Record<string, Record<string, boolean>>,
    diningSelection: DiningSelectionMetadata
  ) => {
    try {
      await applyDiningSelectionReviseDirect(passengers, diningSelection);
    } catch (error) {
      dispatch(
        setErrorManagerCode(
          typeof error === 'object' && error && 'issue_code' in error
            ? String((error as { issue_code?: string }).issue_code ?? 'unknown_error')
            : 'unknown_error'
        )
      );
      throw error;
    }
  };

  const handleDiningApply = () => {
    resetDiningDrawerState();
    setShowSkeleton(true);

    void (async () => {
      try {
        await applyDiningSelectionRevise();
      } catch (error) {
        console.error('INT163 revise thematic reservations failed', error);
      } finally {
        await refetchBooking();
        setShowSkeleton(false);
      }
    })();
  };

  const openDiningDrawerFromCard = (obsCard: OBSObjI) => {
    const bookedDiningReservations = getBookedDiningReservations(obsCard);
    setShopRequestToRestaurants(true);
    const bookedPassengerIds = booking
      ? new Set(getAlreadyBookedPassengerId(obsCard, booking, false, true))
      : new Set<string>();
    const bookedDiningPassengers =
      booking?.cabins?.reduce<Record<string, Record<string, boolean>>>((acc, cabin) => {
        if (cruiseId && cabin?.cruise?.id !== cruiseId) {
          return acc;
        }

        if (!cabin?.id) {
          return acc;
        }

        const selectedMap = (cabin.passengers ?? []).reduce<Record<string, boolean>>(
          (paxAcc, passenger) => {
            const passengerId =
              typeof passenger === 'object' && passenger !== null ? passenger.id : passenger;
            if (passengerId) {
              paxAcc[passengerId] = bookedPassengerIds.has(passengerId);
            }
            return paxAcc;
          },
          {}
        );

        if (Object.values(selectedMap).some(Boolean)) {
          acc[cabin.id] = selectedMap;
        }

        return acc;
      }, {}) ?? undefined;

    const preselectedDiningPassengers =
      bookedDiningPassengers && Object.keys(bookedDiningPassengers).length > 0
        ? bookedDiningPassengers
        : undefined;

    if (bookedDiningReservations.length > 0) {
      handleEditRestaurantReservation(
        obsCard,
        bookedDiningReservations,
        preselectedDiningPassengers
      );
    } else {
      handleMakeRestaurantReservation(
        obsCard,
        bookedDiningReservations,
        preselectedDiningPassengers
      );
    }
  };

  const buildDiningRefundSelectionMap = (
    obsCard: OBSObjI
  ): Record<string, Record<string, boolean>> => {
    if (!booking || !cruiseId) {
      return {};
    }

    const refundableCodes = new Set(
      getObsRefundOverviewItems(obsCard)
        .map((item) => item.code)
        .filter(Boolean) as string[]
    );
    if (!refundableCodes.size) {
      return {};
    }

    const cruiseCabins = (booking.cabins ?? []).filter((cabin) => cabin?.cruise?.id === cruiseId);
    const passengerToCabinMap = new Map<string, string>();
    const cabinPassengersMap = new Map<string, string[]>();

    cruiseCabins.forEach((cabin) => {
      if (!cabin.id) return;
      const passengerIds = (cabin.passengers ?? [])
        .map((passenger) =>
          typeof passenger === 'object' && passenger !== null ? passenger.id : passenger
        )
        .filter((passengerId): passengerId is string => Boolean(passengerId));
      cabinPassengersMap.set(cabin.id, passengerIds);
      passengerIds.forEach((passengerId) => passengerToCabinMap.set(passengerId, cabin.id));
    });

    const prepaidBookingsForCruise =
      booking.prepaid?.bookings?.filter(
        (prepaidBooking) => prepaidBooking.cruise.id === cruiseId
      ) ?? [];
    const selectionMap: Record<string, Record<string, boolean>> = {};

    prepaidBookingsForCruise
      .flatMap((prepaidBooking) => prepaidBooking.onboardServices ?? [])
      .filter(
        (service) =>
          service.bookingStatus?.code === BookingStatusEnum.BOOKED &&
          Boolean(service.code) &&
          refundableCodes.has(service.code)
      )
      .forEach((service) => {
        if (service.priceBasis === PriceBasisEnum.PER_CABIN && service.cabin?.id) {
          const cabinId = service.cabin.id;
          const passengerIds = cabinPassengersMap.get(cabinId) ?? [];
          if (!selectionMap[cabinId]) {
            selectionMap[cabinId] = {};
          }
          passengerIds.forEach((passengerId) => {
            selectionMap[cabinId][passengerId] = true;
          });
          return;
        }

        if (service.priceBasis === PriceBasisEnum.PER_PERSON && service.passenger?.id) {
          const passengerId = service.passenger.id;
          const cabinId = passengerToCabinMap.get(passengerId);
          if (!cabinId) {
            return;
          }
          if (!selectionMap[cabinId]) {
            selectionMap[cabinId] = {};
          }
          selectionMap[cabinId][passengerId] = true;
        }
      });

    return selectionMap;
  };

  const handleDiningRefundRequest = (obsCard: OBSObjI) => {
    if (!isRefundEnabled) {
      return;
    }

    const selectedObsFromCatalog =
      (obs?.onboardServices ?? []).find((item) => item.code === obsCard.code) ?? obsCard;
    const diningRefundSelection = buildDiningRefundSelectionMap(selectedObsFromCatalog);

    setRefundPassengersToProcess(diningRefundSelection);
    setPendingDiningRefundSelection(null);
    setIsShopRequestFailed(false);
    setShouldShowAddOnSection(false);
    setIsDrawerOpen(true);
    setIsRefundConfirmationOpen(true);
    dispatch(isLayerMyAreaExcursionOpen(false));
    dispatch(selectedMyAreaExcursionCard(null));
    dispatch(selectedMyAreaOBSCard(selectedObsFromCatalog));
  };

  useEffect(() => {
    if (!isDrawerOpen || !pendingDiningRefundSelection) {
      return;
    }

    const animationFrameId = requestAnimationFrame(() => {
      setRefundPassengersToProcess(pendingDiningRefundSelection);
      setPendingDiningRefundSelection(null);
    });

    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [isDrawerOpen, pendingDiningRefundSelection]);

  const hasRefundPassengersSelected = Object.values(refundPassengersToProcess).some(
    (cabinPassengers) => Object.values(cabinPassengers).some(Boolean)
  );
  const hasNewAddonPassengersSelected = hasPassengerSelectionExcludingPassengerIds(
    passengersToAdd,
    passengerIdsInCartForActiveCard
  );
  const selectedRefundItemCode = isExcursionLayerOpen
    ? selectedExcursionCard?.code
    : selectedOBSCard?.code;
  const isAllInclusiveOrCombinedRefundDrawer = isExcursionLayerOpen
    ? isAllInclusiveByCmsOrTypeCode(allInclusiveCmsItems, selectedRefundItemCode)
    : isAllInclusiveOrCombinedObsRefund(
        selectedOBSCard,
        allInclusiveCmsItems,
        obs?.onboardServices
      );
  const shouldRenderRefundPassengersSection = isRefundEnabled && !isViewDetailDrawer;
  const refundDrawerSecondButtonLabel =
    propertiesFromPlanMyCruiseContainer.refundAddPassengersButtonLabel;
  const cabinsForCruise = useMemo(() => {
    return sortCabinsByPassengerOrder(getCabinsWithPassengersForCruise(booking, cruiseId), booking);
  }, [booking, cruiseId]);
  const activeCruiseCabinIds = useMemo(
    () =>
      cabinsForCruise
        .map((cabin) => cabin.id)
        .sort(
          (first, second) => Number(second === activeCabinId) - Number(first === activeCabinId)
        ),
    [cabinsForCruise, activeCabinId]
  );
  const shouldGroupByStateroom = activeCruiseCabinIds.length > 1;
  const useUnifiedRefundPassengersForMultiCabin =
    shouldGroupByStateroom && isAllInclusiveOrCombinedRefundDrawer;
  const getIsNoEligibleAddonPassengersForCabin = (cabinId?: string): boolean =>
    isExcursionLayerOpen
      ? isNoEligiblePassengersForExcursion(selectedExcursionCard, shopExcursion, cabinId, booking)
      : isNoEligiblePassengersForOBS(selectedOBSCard, shopOBS, cabinId, booking);
  const isNoEligibleAddonPassengers = getIsNoEligibleAddonPassengersForCabin(activeCabinId);
  const addonNoEligibleByCabin = activeCruiseCabinIds.reduce<Record<string, boolean>>(
    (result, cabinId) => {
      result[cabinId] = getIsNoEligibleAddonPassengersForCabin(cabinId);
      return result;
    },
    {}
  );
  const hasEligibleAddonPassengers = shouldGroupByStateroom
    ? activeCruiseCabinIds.some((cabinId) => !addonNoEligibleByCabin[cabinId])
    : !isNoEligibleAddonPassengers;
  const shouldRenderAddOnPassengersSection =
    !isViewDetailDrawer &&
    shouldShowAddOnSection &&
    !isAllInclusiveOrCombinedRefundDrawer &&
    !isShopRequestFailed &&
    hasEligibleAddonPassengers;
  const shouldRenderAddOnPassengersSectionForCabin = (cabinId: string): boolean =>
    shouldRenderAddOnPassengersSection &&
    activeDrawerCardForSelection != null &&
    (!shouldGroupByStateroom ||
      hasRemainingAddonEligiblePassengersInCabin(
        activeDrawerCardForSelection,
        booking,
        cabinId,
        isExcursionLayerOpen,
        cartItems
      ));

  const cabinIdsForAddonRemainingCheck = useMemo(
    () =>
      isMultiCabinBooking
        ? drawerCabinIdsForCart
        : activeCabinId
        ? [activeCabinId]
        : drawerCabinIdsForCart,
    [isMultiCabinBooking, drawerCabinIdsForCart, activeCabinId]
  );

  const hasRemainingAddonPassengersToAdd = useMemo(
    () =>
      hasRemainingAddonPassengersForAlreadyPurchasedItem(
        activeDrawerCardForSelection,
        booking,
        cabinIdsForAddonRemainingCheck,
        isExcursionLayerOpen,
        cartItems
      ),
    [
      activeDrawerCardForSelection,
      booking,
      cabinIdsForAddonRemainingCheck,
      isExcursionLayerOpen,
      cartItems,
    ]
  );

  const shouldShowRefundAddPassengersButton =
    isRefundEnabled && shouldRenderAddOnPassengersSection && hasRemainingAddonPassengersToAdd;
  const isRefundOffAddPassengersFlow =
    !isRefundEnabled && shouldRenderAddOnPassengersSection && !isViewDetailDrawer;
  const activeAlreadyPurchasedCard = (
    isExcursionLayerOpen ? selectedExcursionCard : selectedOBSCard
  ) as MyMscExcursion | OBSObjI | null;
  const areAllPassengersBookedOnItem =
    activeAlreadyPurchasedCard != null &&
    Boolean(booking) &&
    areAllPassengersBookedForAlreadyPurchasedItem(
      activeAlreadyPurchasedCard,
      booking,
      activeCabinId,
      isExcursionLayerOpen
    );
  const showHeadsUpInViewDetailDrawer =
    isViewDetailDrawer &&
    !isRefundEnabled &&
    isNoEligibleAddonPassengers &&
    isAlreadyPurchasedItemPaymentFinalized(
      booking,
      cruiseId || undefined,
      selectedRefundItemCode,
      isExcursionLayerOpen
    ) &&
    !areAllPassengersBookedOnItem;
  const shouldHideDrawerFooter =
    isViewDetailDrawer ||
    (!shouldRenderRefundPassengersSection && !shouldRenderAddOnPassengersSection);
  const drawerFirstButtonLabel = isRefundOffAddPassengersFlow
    ? refundDrawerSecondButtonLabel
    : propertiesFromPlanMyCruiseContainer.refundRequestButtonLabel;
  const drawerSecondButtonLabel = shouldShowRefundAddPassengersButton
    ? refundDrawerSecondButtonLabel
    : undefined;
  const isRefundCtaDisabled =
    !hasRefundPassengersSelected || (isRefundEnabled && hasNewAddonPassengersSelected);

  const cabinIdToStateroomNumber = useMemo(
    () =>
      cabinsForCruise.reduce<Record<string, string>>((result, cabin, index) => {
        result[cabin.id] = (index + 1).toString();
        return result;
      }, {}),
    [cabinsForCruise]
  );

  const addonEligibleCabinIds = activeCruiseCabinIds.filter((cabinId) =>
    shouldRenderAddOnPassengersSectionForCabin(cabinId)
  );
  const allEligiblePassengersInCart = shouldGroupByStateroom
    ? addonEligibleCabinIds.length > 0 &&
      addonEligibleCabinIds.every((cabinId) => allPassengersInCartByCabin[cabinId])
    : allPassengersInCart;
  const shouldRenderCarParkingInput =
    shouldRenderAddOnPassengersSection &&
    hasRemainingAddonPassengersToAdd &&
    !allEligiblePassengersInCart &&
    !isExcursionLayerOpen &&
    selectedOBSCard?.type?.code === 'PARK';
  const shouldRenderLongDescriptionInDrawer =
    shouldGroupByStateroom ||
    isAllInclusiveOrCombinedRefundDrawer ||
    isViewDetailDrawer ||
    shouldRenderCarParkingInput ||
    !shouldRenderAddOnPassengersSection;
  const isAddPassengersCtaDisabled =
    allEligiblePassengersInCart ||
    !hasNewAddonPassengersSelected ||
    (isRefundEnabled && hasRefundPassengersSelected) ||
    (shouldRenderCarParkingInput &&
      (!carParkingInput?.model.trim() || !carParkingInput?.plate.trim()));

  const activeDrawerCard = (isExcursionLayerOpen ? selectedExcursionCard : selectedOBSCard) as
    | MyMscExcursion
    | OBSObjI
    | null;
  const isActiveDrawerItemInCart = Boolean(
    activeDrawerCard && cartItems?.length && isItemOnCart(activeDrawerCard, cartItems)
  );
  const shouldShowAlreadyInCartMessage =
    isMultiCabinBooking &&
    isRefundOffAddPassengersFlow &&
    isDrawerOpen &&
    isActiveDrawerItemInCart &&
    !allEligiblePassengersInCart;

  const alreadyPurchasedDrawerLongDescription = useMemo(() => {
    if (isExcursionLayerOpen && selectedExcursionCard && !selectedExcursionCard.isPackage) {
      return (
        <Text
          styleOption={passengerDrawerStyles['passengers__excursionDesc']}
          text={`${extractLongDescription(selectedExcursionCard.longDescription ?? '')}`}
        />
      );
    }
    if (!isExcursionLayerOpen && selectedOBSCard?.longDescription) {
      const linkedMinorCard = getLinkedMinorObs(
        selectedOBSCard,
        allObsCatalog,
        allInclusiveCmsItems
      );
      const adultRaw = selectedOBSCard.longDescription as string | { html?: string } | undefined;
      let adultHtml = '';
      if (typeof adultRaw === 'object' && adultRaw !== null && 'html' in adultRaw) {
        adultHtml = adultRaw.html ?? '';
      } else if (typeof adultRaw === 'string') {
        adultHtml = adultRaw;
      }

      const minorRaw = linkedMinorCard?.longDescription as string | { html?: string } | undefined;
      let minorHtml = '';
      if (typeof minorRaw === 'object' && minorRaw !== null && 'html' in minorRaw) {
        minorHtml = minorRaw.html ?? '';
      } else if (typeof minorRaw === 'string') {
        minorHtml = minorRaw;
      }

      return (
        <>
          <Text
            styleOption={passengerDrawerStyles['passengers__excursionDesc']}
            text={`${extractLongDescription(adultHtml, true)}`}
          />
          {minorHtml && (
            <Text
              styleOption={passengerDrawerStyles['passengers__excursionDesc']}
              text={`${extractLongDescription(minorHtml, true)}`}
            />
          )}
        </>
      );
    }
    return null;
  }, [
    isExcursionLayerOpen,
    selectedExcursionCard,
    selectedOBSCard,
    allObsCatalog,
    allInclusiveCmsItems,
  ]);

  const alreadyPurchasedDrawerAdditionalNotesTooltip = useMemo(() => {
    let longDescription = '';
    if (isExcursionLayerOpen) {
      longDescription = selectedExcursionCard?.longDescription ?? '';
    } else {
      const raw = selectedOBSCard?.longDescription as string | { html?: string } | undefined;
      if (typeof raw === 'object' && raw !== null && 'html' in raw) {
        longDescription = raw.html ?? '';
      } else if (typeof raw === 'string') {
        longDescription = raw;
      }
    }

    const tooltipContent = extractTooltipContent(longDescription ?? '');
    if (!tooltipContent) {
      return null;
    }

    return (
      <div className="additional-notes-container">
        <Text
          text={drawerProps.tooltipLabel}
          styleOption={'body-default'}
          tagHtml={'span'}
        />
        <TooltipNew
          appliedCssClassNames="default-text"
          triggerAriaLabel={drawerProps.tooltipLabel}
          content={
            <Text
              text={tooltipContent}
              styleOption={'body-xsmall'}
            />
          }
          positionStyle="top"
        >
          <div>
            <Icon
              icon={drawerProps.tooltipIcon}
              ariaHidden={true}
            />
          </div>
        </TooltipNew>
      </div>
    );
  }, [isExcursionLayerOpen, selectedExcursionCard, selectedOBSCard, drawerProps]);

  const handleOpenRefundConfirmation = () => {
    if (!hasRefundPassengersSelected) {
      return;
    }
    setIsRefundConfirmationOpen(true);
  };

  const handleCloseRefundConfirmation = () => {
    setIsRefundConfirmationOpen(false);
    setIsDrawerOpen(false);
  };

  const getObsRefundOverviewItems = (card: OBSObjI | null): OBSObjI[] => {
    if (!card) {
      return [];
    }
    const sourceObsItems = allObsCatalog.length > 0 ? allObsCatalog : obs?.onboardServices ?? [];
    // Resolve booked OBS across ALL cabins of the cruise (not just the active cabin):
    // a combined package's minor item can be booked in a different cabin and may be
    // absent from the active user's OBS catalog, so the active-cabin-only lookup would
    // fail to resolve it and its code would be dropped from the refund payload.
    const bookedObsByCode = new Map<string, OBSObjI>();
    if (booking?.prepaid?.bookings && cruiseId) {
      booking.prepaid.bookings
        .filter((item) => item.cruise.id === cruiseId)
        .forEach((item) => {
          item.onboardServices?.forEach((service) => {
            if (!service.code) return;
            bookedObsByCode.set(service.code, {
              code: service.code,
              description: service.description,
              type: { code: service.type },
              deliveryDate: service.deliveryDate,
            } as OBSObjI);
          });
        });
    }

    const directRelatedCodes = [
      ...(card.prepaidItems?.serviceCodes?.adults ?? []),
      ...(card.prepaidItems?.serviceCodes?.minors ?? []),
      ...getCmsRelatedCodes(allInclusiveCmsItems, card.code),
    ].filter((code): code is string => Boolean(code));

    const relatedItems = directRelatedCodes
      .map((code) => sourceObsItems.find((item) => item.code === code) ?? bookedObsByCode.get(code))
      .filter((item): item is OBSObjI => Boolean(item));

    const reverseRelatedItems =
      sourceObsItems.filter((item) => {
        const itemCodes = [
          ...(item.prepaidItems?.serviceCodes?.adults ?? []),
          ...(item.prepaidItems?.serviceCodes?.minors ?? []),
        ];
        return itemCodes.includes(card.code ?? '');
      }) ?? [];

    const selectedCode = card.code;
    const selectedObsItem = selectedCode
      ? sourceObsItems.find((item) => item.code === selectedCode) ??
        bookedObsByCode.get(selectedCode) ??
        card
      : card;

    return [
      selectedObsItem,
      ...relatedItems,
      ...reverseRelatedItems.filter((item) => item.code !== card.code),
    ].filter(
      (item, index, array) => index === array.findIndex((candidate) => candidate.code === item.code)
    );
  };

  const getRefundItemCodes = () => {
    if (isExcursionLayerOpen) {
      const selectedCode = selectedExcursionCard?.code;
      return [selectedCode, ...getCmsRelatedCodes(allInclusiveCmsItems, selectedCode)].filter(
        Boolean
      ) as string[];
    }

    return getObsRefundOverviewItems(selectedOBSCard)
      .map((item) => item.code)
      .filter(Boolean) as string[];
  };

  const buildRefundPayload = () => {
    if (!booking || !cruiseId) {
      return null;
    }

    const refundItemCodes = new Set(getRefundItemCodes());
    const selectedPassengerIds = new Set(getSelectedRefundPassengerIds(refundPassengersToProcess));
    const selectedCabinIds = new Set(getSelectedRefundCabinIds(refundPassengersToProcess));
    const prepaidBookingsForCruise =
      booking.prepaid?.bookings?.filter(
        (prepaidBooking) => prepaidBooking.cruise.id === cruiseId
      ) ?? [];

    if (isExcursionLayerOpen) {
      const excursions = prepaidBookingsForCruise
        .flatMap((prepaidBooking) => prepaidBooking.excursions ?? [])
        .filter(
          (item) =>
            item.id &&
            item.code &&
            refundItemCodes.has(item.code) &&
            hasSameExcursionStartDate(item.startDate, selectedExcursionCard?.startDate) &&
            item.bookingStatus?.code === BookingStatusEnum.BOOKED &&
            ((item.priceBasis === PriceBasisEnum.PER_PERSON &&
              item.passenger?.id &&
              selectedPassengerIds.has(item.passenger.id)) ||
              (item.priceBasis === PriceBasisEnum.PER_CABIN &&
                item.cabin?.id &&
                selectedCabinIds.has(item.cabin.id)))
        )
        .map((item) =>
          item.priceBasis === PriceBasisEnum.PER_CABIN && item.cabin?.id
            ? { id: item.id, cabin: { id: item.cabin.id } }
            : { id: item.id, passenger: { id: item.passenger?.id ?? '' } }
        );

      return {
        cruise: { id: cruiseId },
        excursions,
      };
    }

    const onboardServices = prepaidBookingsForCruise
      .flatMap((prepaidBooking) => prepaidBooking.onboardServices ?? [])
      .filter(
        (item) =>
          item.id &&
          item.code &&
          refundItemCodes.has(item.code) &&
          item.bookingStatus?.code === BookingStatusEnum.BOOKED &&
          ((item.priceBasis === PriceBasisEnum.PER_PERSON &&
            item.passenger?.id &&
            selectedPassengerIds.has(item.passenger.id)) ||
            (item.priceBasis === PriceBasisEnum.PER_CABIN &&
              item.cabin?.id &&
              selectedCabinIds.has(item.cabin.id)))
      )
      .map((item) =>
        item.priceBasis === PriceBasisEnum.PER_CABIN && item.cabin?.id
          ? { id: item.id, cabin: { id: item.cabin.id } }
          : { id: item.id, passenger: { id: item.passenger?.id ?? '' } }
      );

    return {
      cruise: { id: cruiseId },
      onboardServices,
    };
  };

  const handleConfirmRefund = async () => {
    const refundPayload = buildRefundPayload();
    if (!refundPayload || !bookingNumber) {
      return;
    }

    // Combined packages span multiple OBS lines (e.g. adult + minor ALLINC); list every name.
    const combinedObsName = getObsRefundOverviewItems(selectedOBSCard)
      .map((overviewItem) => overviewItem.description)
      .filter((description): description is string => Boolean(description))
      .join(', ');

    const refundedItemName =
      selectedExcursionCard?.name ||
      selectedExcursionCard?.description ||
      combinedObsName ||
      selectedOBSCard?.description ||
      '';

    const showRefundErrorDrawer = () => {
      setRefundErrorDescription(
        replacePlaceholders(propertiesFromPlanMyCruiseContainer.refundErrorDescription ?? '', {
          refundedItemName,
        })
      );
      setIsRefundErrorOpen(true);
      setIsRefundConfirmationOpen(false);
    };

    setIsRefundProcessing(true);
    const abortController = new AbortController();
    refundAbortControllerRef.current = abortController;
    try {
      const refundApi = new PrepaidBookingRefundMyMSC(false, false, refundPayload, {
        bookingNumber,
      });
      const response = await refundApi.sendData(abortController.signal);
      if (!isRefundResponseSuccessful(response)) {
        console.error('Refund request contains failed entries', response);
        showRefundErrorDrawer();
        return;
      }

      setRefundSuccessDescription(
        replacePlaceholders(propertiesFromPlanMyCruiseContainer.refundSuccessDescription ?? '', {
          refundedItemName,
        })
      );
      setIsRefundConfirmationOpen(false);
      setIsRefundSuccessOpen(true);
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') {
        return;
      }
      console.error('Refund request failed', error);
      showRefundErrorDrawer();
    } finally {
      setIsRefundProcessing(false);
      refundAbortControllerRef.current = null;
    }
  };

  const handleAbortRefundProcessing = () => {
    refundAbortControllerRef.current?.abort();
    resetDrawerState();
    setIsRefundConfirmationOpen(false);
  };

  const handleRefundConfirmationClose = () => {
    if (isRefundProcessing) {
      handleAbortRefundProcessing();
      return;
    }
    resetDrawerState();
  };

  const handleRefundConfirmationClear = () => {
    if (isRefundProcessing) {
      handleAbortRefundProcessing();
      return;
    }
    handleCloseRefundConfirmation();
  };

  const handleCloseRefundSuccess = async () => {
    const shouldRefreshObs =
      !isExcursionLayerOpen &&
      isAllInclusiveOrCombinedObsRefund(
        selectedOBSCard,
        allInclusiveCmsItems,
        obs?.onboardServices
      );
    const shouldRefreshExcursions =
      isExcursionLayerOpen &&
      isAllInclusiveByCmsOrTypeCode(allInclusiveCmsItems, selectedExcursionCard?.code);

    openLoader('.loader');
    // Close drawers before clearing success state so the underlying refund drawer
    // does not briefly reopen while async refresh runs.
    setIsDrawerOpen(false);
    toggleDisplayOverlay(false);
    setIsRefundSuccessOpen(false);
    setShowSkeleton(true);

    try {
      // Booking must be refreshed first so INT130/INT133 return updated availability.
      await refetchBooking();

      if (shouldRefreshObs || shouldRefreshExcursions) {
        await refreshAllInclusiveCatalog({
          dispatch,
          cruiseId,
          bookingNumber,
          refreshObs: shouldRefreshObs,
          refreshExcursions: shouldRefreshExcursions,
          includeDepartureAndArrivalPorts:
            !propertiesFromPlanMyCruiseContainer.disableEmbarkAndDisembarkExcursions,
        });
      }
    } finally {
      setShowSkeleton(false);
      closeLoader('.loader');
      resetDrawerState();
    }
  };

  const handleCloseRefundError = () => {
    resetDrawerState();
  };

  const isCardClickable = (event?: React.MouseEvent | React.TouchEvent | React.KeyboardEvent) => {
    if (!event) return false;

    const target = event.target as HTMLElement;

    return !target.closest('button, a');
  };

  const onCardClick = (
    card: MyMscExcursion | OBSObjI,
    isExcursion: boolean,
    event?: React.MouseEvent | React.TouchEvent | React.KeyboardEvent
  ) => {
    if (!isCardClickable(event)) return;

    //analytics trigger event

    openDrawer(card, isExcursion);
  };

  const openDrawer = (card: MyMscExcursion | OBSObjI, isExcursion: boolean) => {
    if (isExcursion) {
      handleOpenExcursionDrawer(card as MyMscExcursion);
    } else {
      const obsCard = card as OBSObjI;
      if (isDiningObsItem(obsCard)) {
        const isTimeslotUnavailable = Boolean(
          card.code && diningTimeslotsUnavailableByCode[card.code]
        );
        if (!isTimeslotUnavailable) {
          openDiningDrawerFromCard(obsCard);
        }
      } else {
        handleOpenObsDrawer(obsCard);
      }
    }
  };

  const renderAlreadyPurchasedCardButton = (
    card: MyMscExcursion | OBSObjI,
    isExcursion: boolean,
    cardTitle: string
  ) => {
    const ctaMode = getCardCtaMode(card, isExcursion);
    if (ctaMode === 'hidden') {
      return null;
    }

    const buttonLabel = ctaMode === 'viewDetail' ? resolvedViewDetailButtonLabel : editButtonLabel;
    if (!buttonLabel) {
      return null;
    }

    return (
      <Button
        text={buttonLabel}
        styleOption={'cmp-button__secondary'}
        onClick={() => {
          triggerClickCtaEvent({
            cta_dest_link: '',
            click_main_name: buttonLabel,
            container_info: getContainerInfo(document.querySelector('.alreadypurchasedcontainer')),
            element_position: `Already Purchased - ${cardTitle}`,
            element_type: 'button',
            click_location: 'fixed',
          });
          openDrawer(card, isExcursion);
        }}
      />
    );
  };

  const renderExcursions = (type: AlreadyPurchasedSectionRouteMappingProps) => {
    const isNotEmpty = booking && excursionsPurchased && excursionsPurchased?.length > 0;
    return (
      <div
        className={clsx('already-purchased-container__category', {
          'is-empty': !isNotEmpty,
        })}
      >
        {isNotEmpty ? (
          <>
            <Text
              text={type.routeLabel}
              tagHtml={'h2'}
              styleOption={styles['already-purchased-container__category__title']}
            />
            <div className={styles['already-purchased-container__itemSection']}>
              {excursionsPurchased?.map((excursion: MyMscExcursion, index: number) => {
                const preTitleFields = resolveExcursionPreTitleFields(
                  excursion,
                  itineraryDayDetailsByDate,
                  getDepartureDate(booking)
                );

                return (
                  <PostBookingCard
                    key={excursion?.id ?? index}
                    id={String(excursion?.id ?? index)}
                    image={getCardImage(excursion, urlAct)}
                    title={excursion?.name ?? excursion.description}
                    imageCode={excursion?.code ?? ''}
                    imageType="act"
                    placeholderImagePath={getActPlaceholderImagePath()}
                    displayedPills={propertiesFromPlanMyCruiseContainer.cardPillConfigurations.filter(
                      (pill) => pill.pillType === 'booked'
                    )}
                    onClick={(e) => onCardClick(excursion, true, e)}
                  >
                    <PostBookingCard.PreTitle
                      text={`${propertiesFromPlanMyCruiseContainer.dayLabel}`}
                      day={preTitleFields.day}
                      portCode={preTitleFields.portCode}
                      startDate={preTitleFields.startDate}
                      dayAtSeaLabelValue={propertiesFromPlanMyCruiseContainer.dayAtSeaLabelValue}
                      explorerPackageLabel={
                        excursion.isPackage
                          ? propertiesFromPlanMyCruiseContainer.explorerPackageLabel
                          : ''
                      }
                    />
                    <PostBookingCard.Title
                      packageTitle={excursion?.name ?? excursion.description}
                    />
                    <PostBookingCard.Description
                      descriptionItems={[
                        ...(!excursion.isPackage && excursion.duration > 0
                          ? [
                              {
                                descriptionLabel: propertiesFromPlanMyCruiseContainer.durationLabel,
                                descriptionValue: managePlurals(
                                  excursion.duration,
                                  replacePlaceholders(
                                    propertiesFromPlanMyCruiseContainer.durationValueLabel,
                                    {
                                      duration: excursion.duration.toString(),
                                    }
                                  )
                                ),
                              },
                            ]
                          : []),
                        {
                          descriptionLabel: propertiesFromPlanMyCruiseContainer.codeLabel,
                          descriptionValue: excursion.code,
                        },
                      ]}
                    />
                    {booking &&
                      getAlreadyBookedPassengerId(excursion, booking, true).length > 0 && (
                        <PostBookingCard.Description
                          descriptionItems={[
                            {
                              descriptionLabel:
                                propertiesFromPlanMyCruiseContainer.alreadyBookedLabel,
                              descriptionValue: passengerDetailsSeparator
                                ? getNamesOfAlreadyBookedPassengers(
                                    getAlreadyBookedPassengerId(excursion, booking, true),
                                    booking
                                  ).join(passengerDetailsSeparator)
                                : getNamesOfAlreadyBookedPassengers(
                                    getAlreadyBookedPassengerId(excursion, booking, true),
                                    booking
                                  ),
                            },
                          ]}
                        />
                      )}
                    {renderAlreadyPurchasedCardButton(
                      excursion,
                      true,
                      excursion.name ?? excursion.description ?? ''
                    )}
                  </PostBookingCard>
                );
              })}
            </div>
          </>
        ) : (
          <div className={styles['already-purchased-container__empty']}>
            <Text
              text={type.routeLabel}
              tagHtml={'h2'}
              styleOption={styles['already-purchased-container__category__title']}
            />
            <Text
              text={type.routeDescription}
              tagHtml="p"
              key={type.routeDescription}
              styleOption={styles['already-purchased-container__empty-text']}
            />
          </div>
        )}
        <Button
          text={type.ctaLabel}
          styleOption={clsx('cmp-button__primary', 'already-purchased-container__add-button')}
          key={type.ctaLabel}
          onClick={() => {
            navigateOrRedirectToRoute(type.routeUrl, navigate);
          }}
        />
      </div>
    );
  };

  // Booked passengers for the card, merging linked related packages so the combined
  // package lists everyone who booked any part of it.
  const getMergedBookedPassengerIds = (obsCard: OBSObjI): string[] =>
    getMergedBookedPassengerIdsForCombinedObs(
      obsCard,
      booking,
      allObsCatalog,
      allInclusiveCmsItems
    );

  const renderObs = (type: AlreadyPurchasedSectionRouteMappingProps) => {
    const specificTypeObs =
      booking && obsPurchased && obsPurchased.length > 0
        ? obsPurchased?.filter(
            (obs) =>
              Object.keys(type.routeTypes).find((routeType) => routeType === obs.type.code) &&
              // Minor ALLINC packages are merged into the linked adult card, never shown separately.
              !isHiddenMinorObs(obs, allObsCatalog, allInclusiveCmsItems)
          )
        : [];
    return (
      <div
        className={clsx('already-purchased-container__category', {
          'is-empty': !specificTypeObs.length,
        })}
      >
        {specificTypeObs.length ? (
          <>
            <Text
              text={type.routeLabel}
              tagHtml={'h2'}
              styleOption={styles['already-purchased-container__category__title']}
            />
            <div className={styles['already-purchased-container__itemSection']}>
              {specificTypeObs.map((obs: OBSObjI, index: number) => {
                const isDiningCard = isDiningObsItem(obs);
                const diningReservations = isDiningCard
                  ? sortDiningReservationsChronologically(getBookedDiningReservations(obs))
                  : [];

                const isPendingReservation =
                  diningReservations.length < (obs.maximumSlotsBookable ?? 1);
                const pillType =
                  isDiningCard && isPendingReservation ? 'pendingReservation' : 'booked';

                const isTimeslotUnavailable = Boolean(
                  obs.code && diningTimeslotsUnavailableByCode[obs.code]
                );

                return (
                  <PostBookingCard
                    key={obs.index ?? index}
                    id={String(obs.index ?? index)}
                    image={getCardImage(obs, urlObs)}
                    title={obs.description ?? ''}
                    imageCode={obs?.code ?? ''}
                    imageType="obs"
                    placeholderImagePath={getObsPlaceholderImagePath()}
                    displayedPills={propertiesFromPlanMyCruiseContainer.cardPillConfigurations.filter(
                      (pill) => pill.pillType === pillType
                    )}
                    onClick={(e) => onCardClick(obs, false, e)}
                  >
                    {obs.type.code && (
                      <PostBookingCard.PreTitle text={type.routeTypes[obs.type.code]} />
                    )}
                    <PostBookingCard.Title packageTitle={obs.description ?? ''} />
                    {booking && getMergedBookedPassengerIds(obs).length > 0 && (
                      <PostBookingCard.Description
                        descriptionItems={[
                          {
                            descriptionLabel:
                              propertiesFromPlanMyCruiseContainer.alreadyBookedLabel,
                            descriptionValue: passengerDetailsSeparator
                              ? getNamesOfAlreadyBookedPassengers(
                                  getMergedBookedPassengerIds(obs),
                                  booking
                                ).join(passengerDetailsSeparator)
                              : getNamesOfAlreadyBookedPassengers(
                                  getMergedBookedPassengerIds(obs),
                                  booking
                                ),
                          },
                        ]}
                      />
                    )}

                    {isDiningCard && diningReservations.length > 0 && (
                      <div
                        className={styles['already-purchased-container__restaurant-reservations']}
                      >
                        <Text
                          text={specialtyRestaurantReservationsLabel ?? ''}
                          styleOption={
                            styles['already-purchased-container__restaurant-reservations-label']
                          }
                        />
                        {diningReservations.map((reservation) => (
                          <Text
                            key={`${reservation.restaurantCode}-${reservation.day}-${reservation.hour}`}
                            text={formatDiningReservationSummary(
                              reservation,
                              (obs.maximumSlotsBookable ?? 1) > 1
                            )}
                            styleOption={
                              styles['already-purchased-container__restaurant-reservation-item']
                            }
                          />
                        ))}
                      </div>
                    )}
                    {isDiningCard ||
                    (isRefundEnabled && Boolean(specialtyRestaurantRequestRefundLabel)) ||
                    getCardCtaMode(obs, false) !== 'hidden' ? (
                      <div
                        className={
                          isDiningCard
                            ? styles['already-purchased-container__restaurant-actions']
                            : styles['already-purchased-container__item-actions']
                        }
                      >
                        {isRefundEnabled &&
                          isDiningCard &&
                          Boolean(specialtyRestaurantRequestRefundLabel) && (
                            <Button
                              text={specialtyRestaurantRequestRefundLabel ?? ''}
                              styleOption={clsx(
                                'cmp-button__link',
                                'already-purchased-container__restaurant-refund-button'
                              )}
                              onClick={() => {
                                triggerClickCtaEvent({
                                  cta_dest_link: '',
                                  click_main_name: specialtyRestaurantRequestRefundLabel ?? '',
                                  container_info: getContainerInfo(
                                    document.querySelector('.alreadypurchasedcontainer')
                                  ),
                                  element_position: `Already Purchased - ${obs.description}`,
                                  element_type: 'button',
                                  click_location:
                                    allIndexedCards
                                      ?.find((c) => c.code === obs.code)
                                      ?.index?.toString() ?? '',
                                });
                                handleDiningRefundRequest(obs);
                              }}
                            />
                          )}
                        {isDiningCard
                          ? (() => {
                              const diningActionLabel =
                                diningReservations.length > 0
                                  ? editButtonLabel
                                  : specialtyRestaurantMakeReservationLabel;
                              if (!diningActionLabel) {
                                return null;
                              }

                              return (
                                <Button
                                  text={diningActionLabel}
                                  styleOption={clsx(
                                    'cmp-button__secondary',
                                    'already-purchased-container__restaurant-edit-button'
                                  )}
                                  disabled={isTimeslotUnavailable}
                                  onClick={() => {
                                    triggerClickCtaEvent({
                                      cta_dest_link: '',
                                      click_main_name: diningActionLabel,
                                      container_info: getContainerInfo(
                                        document.querySelector('.alreadypurchasedcontainer')
                                      ),
                                      element_position: `Already Purchased - ${obs.description}`,
                                      element_type: 'button',
                                      click_location:
                                        allIndexedCards
                                          ?.find((c) => c.code === obs.code)
                                          ?.index?.toString() ?? '',
                                    });
                                    // Prevent opening when no timeslots are available
                                    if (isTimeslotUnavailable) return;
                                    openDiningDrawerFromCard(obs);
                                  }}
                                />
                              );
                            })()
                          : renderAlreadyPurchasedCardButton(obs, false, obs.description ?? '')}
                      </div>
                    ) : null}
                  </PostBookingCard>
                );
              })}
            </div>
          </>
        ) : (
          <div className={styles['already-purchased-container__empty']}>
            <Text
              text={type.routeLabel}
              tagHtml={'h2'}
              styleOption={styles['already-purchased-container__category__title']}
            />
            <Text
              text={type.routeDescription}
              tagHtml="p"
              key={type.routeDescription}
              styleOption={styles['already-purchased-container__empty-text']}
            />
          </div>
        )}
        <Button
          text={type.ctaLabel}
          styleOption={clsx('cmp-button__primary', 'already-purchased-container__add-button')}
          onClick={() => {
            navigateOrRedirectToRoute(type.routeUrl || {}, navigate);
          }}
        />
      </div>
    );
  };

  if (showSkeleton) {
    return (
      <div className={styles['already-purchased-container']}>
        <Text
          text={title}
          tagHtml="h1"
          styleOption={styles['already-purchased-container__title']}
        />
        <AlreadyPurchasedContainerSkeleton />
      </div>
    );
  }

  const refundDrawerContent = (() => {
    if (isRefundErrorOpen) {
      return (
        <Drawer
          closeIcon={drawerProps.closeDrawerIcon}
          titleIcon={propertiesFromPlanMyCruiseContainer.refundErrorIcon}
          title={propertiesFromPlanMyCruiseContainer.refundErrorTitle}
          firstButtonLabel={propertiesFromPlanMyCruiseContainer.refundErrorButtonCta}
          isDrawerOpen={isDrawerOpen}
          enableClosingByClickingOutside={true}
          onClose={handleCloseRefundError}
          onApply={handleCloseRefundError}
          onClear={() => undefined}
          stylingOption="confirmation-drawer -refund -refund-error"
          showPriceInFooter={false}
          hiddenFooter={false}
        >
          <Text
            text={refundErrorDescription}
            tagHtml="p"
            styleOption={styles['already-purchased-container__refund-error-description']}
          />
        </Drawer>
      );
    }

    if (isConfirmationDrawer) {
      return (
        <Drawer
          title={confirmationDrawerProps?.title}
          titleIcon={confirmationDrawerProps?.titleIcon}
          closeIcon={drawerProps.closeDrawerIcon}
          firstButtonLabel={confirmationDrawerProps?.continueShoppingButtonLabel}
          secondButtonLabel={confirmationDrawerProps?.viewCartButtonLabel}
          isDrawerOpen={isDrawerOpen}
          enableClosingByClickingOutside={true}
          onClose={resetDrawerState}
          onClear={handleNavigateToCart}
          onApply={resetDrawerState}
          stylingOption="confirmation-drawer"
          footerButtonsVariant="secondary"
          showPriceInFooter={false}
        >
          {isExcursionLayerOpen ? (
            <AddToCartOverview
              postBookingCard={selectedExcursionCard}
              passengersToAdd={passengersToAdd}
            />
          ) : (
            <div className="add-to-cart-overview-list">
              {(() => {
                // Combined adult + minor ALLINC packages render as a single merged card.
                const [primaryItem, ...relatedItems] = getObsRefundOverviewItems(selectedOBSCard);
                return primaryItem ? (
                  <AddToCartOverview
                    postBookingCard={primaryItem}
                    relatedCards={relatedItems}
                    passengersToAdd={passengersToAdd}
                  />
                ) : null;
              })()}
            </div>
          )}
        </Drawer>
      );
    }

    if (!isRefundConfirmationOpen && !isRefundSuccessOpen) {
      return (
        <Drawer
          closeIcon={drawerProps.closeDrawerIcon}
          firstButtonLabel={drawerFirstButtonLabel}
          secondButtonLabel={drawerSecondButtonLabel}
          secondButtonDisabled={
            shouldShowRefundAddPassengersButton ? isAddPassengersCtaDisabled : true
          }
          processingFirstButtonLabel={drawerExcursionAEMConfig?.addingToCartButtonLabel}
          processingFirstButtonIcon={drawerExcursionAEMConfig?.addingToCartButtonIcon}
          isProcessing={isAddPassengersProcessing}
          isDrawerOpen={isDrawerOpen}
          enableClosingByClickingOutside={true}
          onClose={resetDrawerState}
          onApply={
            isRefundOffAddPassengersFlow ? handleAddPassengersToCart : handleOpenRefundConfirmation
          }
          onClear={
            shouldShowRefundAddPassengersButton ? handleAddPassengersToCart : () => undefined
          }
          stylingOption="transparent-header -refund"
          disabled={
            isRefundOffAddPassengersFlow
              ? isAddPassengersCtaDisabled
              : shouldRenderRefundPassengersSection
              ? isRefundCtaDisabled
              : true
          }
          showPriceInFooter={false}
          hiddenFooter={shouldHideDrawerFooter}
          footerButtonsVariant={isRefundOffAddPassengersFlow ? 'default' : 'secondary'}
          alreadyInCartMessageLabel={
            shouldShowAlreadyInCartMessage ? drawerProps.alreadyInCartMessageLabel : ''
          }
        >
          <>
            <ImageTitle
              imageCode={selectedExcursionCard?.code ?? selectedOBSCard?.code ?? ''}
              booking={booking}
            />
            {isExcursionLayerOpen && <Overview excursion={selectedExcursionCard} />}
            {showHeadsUpInViewDetailDrawer && <HeadsUpContainer bookingData={booking} />}
            {!isViewDetailDrawer && shouldGroupByStateroom ? (
              <>
                {useUnifiedRefundPassengersForMultiCabin && shouldRenderRefundPassengersSection && (
                  <RefundPassengers
                    key={`refund-passengers-all-cabins-${refundSelectionResetKey}`}
                    isDrawerOpen={isDrawerOpen}
                    onCheckedPassengersChange={handleRefundPassengersChange}
                    showMainTitle={true}
                    showCabinTitle={true}
                  />
                )}
                {(!useUnifiedRefundPassengersForMultiCabin || shouldRenderAddOnPassengersSection) &&
                  activeCruiseCabinIds.map((cabinId, cabinIndex) => {
                    const stateroomNumber =
                      cabinIdToStateroomNumber[cabinId] || (cabinIndex + 1).toString();
                    return (
                      <div
                        key={`refund-add-on-${cabinId}`}
                        className={passengerDrawerStyles['passengers__multiCabinBlock']}
                      >
                        {!useUnifiedRefundPassengersForMultiCabin && (
                          <div className={passengerDrawerStyles['passengers__cabinGroup__title']}>
                            <Text
                              text={replacePlaceholders(drawerProps.stateroomLabel, {
                                id: stateroomNumber,
                              })}
                            />
                          </div>
                        )}
                        {shouldRenderRefundPassengersSection &&
                          !useUnifiedRefundPassengersForMultiCabin && (
                            <RefundPassengers
                              key={`refund-passengers-${cabinId}-${refundSelectionResetKey}`}
                              isDrawerOpen={isDrawerOpen}
                              onCheckedPassengersChange={(checked) =>
                                handleRefundPassengersChange({
                                  ...refundPassengersToProcess,
                                  [cabinId]: checked[cabinId] ?? {},
                                })
                              }
                              cabinIdFilter={cabinId}
                              showMainTitle={true}
                              showCabinTitle={false}
                            />
                          )}
                        {isShopLoading && <PassengersSkeleton />}
                        {shouldRenderAddOnPassengersSectionForCabin(cabinId) && (
                          <Passengers
                            key={`addon-passengers-${cabinId}-${addonSelectionResetKey}`}
                            isDrawerOpen={isDrawerOpen}
                            setPassengersToAdd={(checked) =>
                              handleAddonPassengersChange({
                                ...(passengersToAdd ??
                                  createEmptyPassengerSelection(
                                    booking,
                                    cruiseId || undefined,
                                    activeCabinId
                                  )),
                                [cabinId]: checked[cabinId] ?? {},
                              })
                            }
                            selectedLanguages={selectedLanguages}
                            setSelectedLanguages={setSelectedLanguages}
                            cabinIdFilter={cabinId}
                            showMainTitle={true}
                            showCabinTitle={false}
                            withRefundDivider={
                              shouldRenderRefundPassengersSection &&
                              hasRefundablePassengersInCabinForAlreadyPurchased(
                                (isExcursionLayerOpen ? selectedExcursionCard : selectedOBSCard) as
                                  | MyMscExcursion
                                  | OBSObjI,
                                booking,
                                cabinId,
                                isExcursionLayerOpen
                              )
                            }
                            hideLongDescription={true}
                            hidePassengersInCart
                            isNoEligible={addonNoEligibleByCabin[cabinId] ?? false}
                            onAllPassengersInCartChange={(inCart) =>
                              setAllPassengersInCartByCabin((prev) => ({
                                ...prev,
                                [cabinId]: inCart,
                              }))
                            }
                            hideSelectAllCheckbox={true}
                            showOnlyAddonEligiblePassengers={true}
                            isDiningButtonLoading={isDiningButtonLoading}
                            setIsDiningButtonLoading={setIsDiningButtonLoading}
                          />
                        )}
                      </div>
                    );
                  })}
              </>
            ) : !isViewDetailDrawer ? (
              <>
                {shouldRenderRefundPassengersSection && (
                  <RefundPassengers
                    key={`refund-passengers-${refundSelectionResetKey}`}
                    isDrawerOpen={isDrawerOpen}
                    onCheckedPassengersChange={handleRefundPassengersChange}
                  />
                )}
                {isShopLoading && <PassengersSkeleton />}
                {shouldRenderAddOnPassengersSection && (
                  <Passengers
                    key={`addon-passengers-${addonSelectionResetKey}`}
                    isDrawerOpen={isDrawerOpen}
                    setPassengersToAdd={handleAddonPassengersChange}
                    selectedLanguages={selectedLanguages}
                    setSelectedLanguages={setSelectedLanguages}
                    hidePassengersInCart
                    isNoEligible={isNoEligibleAddonPassengers}
                    onAllPassengersInCartChange={setAllPassengersInCart}
                    hideSelectAllCheckbox={true}
                    withRefundDivider={
                      shouldRenderRefundPassengersSection &&
                      hasRefundablePassengersInCabinForAlreadyPurchased(
                        (isExcursionLayerOpen ? selectedExcursionCard : selectedOBSCard) as
                          | MyMscExcursion
                          | OBSObjI,
                        booking,
                        activeCabinId,
                        isExcursionLayerOpen
                      )
                    }
                    showOnlyAddonEligiblePassengers={true}
                    hideLongDescription={shouldRenderCarParkingInput}
                    isDiningButtonLoading={isDiningButtonLoading}
                    setIsDiningButtonLoading={setIsDiningButtonLoading}
                  />
                )}
              </>
            ) : null}
            {shouldRenderCarParkingInput && (
              <CarParkingInput
                carParkingModelValue={carParkingInput.model}
                setCarParkingModel={(val: string) =>
                  setCarParkingInput((prev) => ({ ...prev, model: val }))
                }
                carParkingPlate={carParkingInput.plate}
                setCarParkingPlate={(val: string) =>
                  setCarParkingInput((prev) => ({ ...prev, plate: val }))
                }
              />
            )}
            {shouldRenderLongDescriptionInDrawer && alreadyPurchasedDrawerLongDescription}
            {!drawerProps?.disableAdditionalNotesTooltip &&
              alreadyPurchasedDrawerAdditionalNotesTooltip}
          </>
        </Drawer>
      );
    }

    if (isRefundConfirmationOpen) {
      return (
        <Drawer
          closeIcon={drawerProps.closeDrawerIcon}
          titleIcon={propertiesFromPlanMyCruiseContainer.refundConfirmationIcon}
          title={propertiesFromPlanMyCruiseContainer.refundConfirmationTitle}
          firstButtonLabel={propertiesFromPlanMyCruiseContainer.refundConfirmButtonLabel}
          secondButtonLabel={propertiesFromPlanMyCruiseContainer.refundCancelButtonLabel}
          processingFirstButtonLabel={propertiesFromPlanMyCruiseContainer.refundProcessingLabel}
          processingFirstButtonIcon={propertiesFromPlanMyCruiseContainer.refundProcessingIcon}
          isProcessing={isRefundProcessing}
          isDrawerOpen={isDrawerOpen}
          enableClosingByClickingOutside={true}
          onClose={handleRefundConfirmationClose}
          onApply={handleConfirmRefund}
          onClear={handleRefundConfirmationClear}
          stylingOption="confirmation-drawer -refund"
          showPriceInFooter={false}
          secondButtonDisabled={false}
          disabled={isRefundProcessing}
        >
          <div
            style={{
              pointerEvents: isRefundProcessing ? 'none' : 'auto',
              opacity: isRefundProcessing ? 0.6 : 1,
            }}
          >
            <div className={styles['already-purchased-container__refund-confirmation-texts']}>
              <Text
                text={
                  isExcursionLayerOpen
                    ? propertiesFromPlanMyCruiseContainer.refundConfirmationDescriptionExcursions
                    : propertiesFromPlanMyCruiseContainer.refundConfirmationDescriptionOBS
                }
                tagHtml="p"
                styleOption={styles['already-purchased-container__refund-confirmation-description']}
              />
              {(isExcursionLayerOpen
                ? propertiesFromPlanMyCruiseContainer.refundConfirmationDescriptionSubtitleExcursions
                : propertiesFromPlanMyCruiseContainer.refundConfirmationDescriptionSubtitleOBS) && (
                <Text
                  text={
                    isExcursionLayerOpen
                      ? propertiesFromPlanMyCruiseContainer.refundConfirmationDescriptionSubtitleExcursions
                      : propertiesFromPlanMyCruiseContainer.refundConfirmationDescriptionSubtitleOBS
                  }
                  tagHtml="p"
                  styleOption={styles['already-purchased-container__refund-confirmation-subtitle']}
                />
              )}
            </div>
            {isExcursionLayerOpen ? (
              <AddToCartOverview
                postBookingCard={selectedExcursionCard}
                passengersToAdd={refundPassengersToProcess}
                useBookedRefundPricing={true}
              />
            ) : (
              <div className="add-to-cart-overview-list">
                {(() => {
                  // Combined adult + minor ALLINC packages render as a single merged card.
                  const [primaryItem, ...relatedItems] = getObsRefundOverviewItems(selectedOBSCard);
                  return primaryItem ? (
                    <AddToCartOverview
                      postBookingCard={primaryItem}
                      relatedCards={relatedItems}
                      passengersToAdd={refundPassengersToProcess}
                      useBookedRefundPricing={true}
                    />
                  ) : null;
                })()}
              </div>
            )}
          </div>
        </Drawer>
      );
    }

    return (
      <Drawer
        closeIcon={drawerProps.closeDrawerIcon}
        titleIcon={propertiesFromPlanMyCruiseContainer.refundSuccessIcon}
        title={propertiesFromPlanMyCruiseContainer.refundSuccessTitle}
        firstButtonLabel={propertiesFromPlanMyCruiseContainer.refundSuccessCloseButtonLabel}
        isDrawerOpen={isDrawerOpen}
        enableClosingByClickingOutside={true}
        onClose={handleCloseRefundSuccess}
        onApply={handleCloseRefundSuccess}
        onClear={() => undefined}
        stylingOption="confirmation-drawer -refund"
        showPriceInFooter={false}
        hiddenFooter={false}
      >
        <Text
          text={refundSuccessDescription}
          tagHtml="p"
        />
      </Drawer>
    );
  })();

  const diningErrorBanner = () => {
    const shouldShowDiningTimeslotsUnavailableBanner =
      Object.keys(diningTimeslotsUnavailableByCode).length > 0;

    if (!shouldShowDiningTimeslotsUnavailableBanner) {
      return null;
    }

    return (
      <div className={styles['already-purchased-container__dining-error-banner']}>
        <HeadsUpInfo
          icon={diningTimeslotsUnavailableBannerIcon ?? ''}
          title={diningTimeslotsUnavailableBannerTitle ?? ''}
          description={diningTimeslotsUnavailableBannerBody ?? ''}
          priority={HeadsUpMessagePriority.DEFAULT}
          visibilityCondition={() => true}
          bgColor={diningTimeslotsUnavailableBannerBgColor}
          fontColor={diningTimeslotsUnavailableBannerFontColor}
          iconAlignment={HeadsUpIconAlignment.TOP}
          closeIcon="close"
        />
      </div>
    );
  };

  const shouldShowDiningTimeslotsUnavailableBanner =
    Object.keys(diningTimeslotsUnavailableByCode).length > 0;

  return (
    <div className={styles['already-purchased-container']}>
      {diningErrorBanner()}
      <Text
        text={title}
        tagHtml="h1"
        styleOption={clsx(styles['already-purchased-container__title'], {
          [styles['already-purchased-container__title--with-dining-error-banner']]:
            shouldShowDiningTimeslotsUnavailableBanner,
        })}
      />

      {effectiveSectionRouteMapping.map((type: AlreadyPurchasedSectionRouteMappingProps) => {
        return Object.keys(type.routeTypes).includes('ACT')
          ? renderExcursions(type)
          : renderObs(type);
      })}
      {refundDrawerContent}

      {isDiningDrawerOpen && selectedRestaurantObs && booking && (
        <DiningMultistepDrawer
          isDrawerOpen={isDiningDrawerOpen}
          booking={booking}
          onClose={handleCloseDiningDrawer}
          onDrawerAbandonConfirmed={handleDiningDrawerConfirm}
          flowConfig={{
            entryPoint: DiningFlowEntryPoint.ALREADY_PURCHASED,
            initialStep: diningDrawerInitialStep,
          }}
          seedContext={{
            preselectedPassengers: selectedRestaurantPassengers,
            preselectedReservations: selectedRestaurantReservations,
            maximumSlotsBookable:
              selectedRestaurantObs.maximumSlotsBookable ??
              selectedRestaurantObs.diningRoomsBookingLimit,
          }}
          onConfirmPassengers={handleDiningConfirmPassengers}
          onApply={handleDiningApply}
          onPersistDiningSelectionForAlreadyPurchased={
            handlePersistDiningSelectionForAlreadyPurchased
          }
          setIsConfirmationDrawer={() => undefined}
          cartReservationRecapProps={
            specialtyRestaurantConfirmReservationLabel
              ? {
                  confirmButtonLabel: specialtyRestaurantConfirmReservationLabel,
                }
              : undefined
          }
          passengerModificationBannerProps={{
            bannerTitle: diningBannerTitle ?? '',
            bannerIcon: diningBannerIcon ?? '',
            bannerBackgroundColor: diningBannerBackgroundColor ?? '',
            bannerFontColor: diningBannerFontColor ?? '',
            bannerText: diningBannerText ?? '',
          }}
        />
      )}
    </div>
  );
}

export default AlreadyPurchasedContainer;
